// chakra imports
import { Box, Flex, Icon, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { useClerk } from '@clerk/clerk-react';
import { MdLogout } from 'react-icons/md';
//   Custom components
import Brand from 'components/sidebar/components/Brand';
import Links from 'components/sidebar/components/Links';

// FUNCTIONS

function SidebarContent(props: { routes: RoutesType[] }) {
	const { routes } = props;
	const { signOut } = useClerk();
	const textColor = useColorModeValue('navy.700', 'white');

	return (
		<Flex direction='column' height='100%' pt='25px' borderRadius='30px'>
			<Brand />
			<Stack direction='column' mt='8px' mb='auto'>
				<Box ps='20px' pe={{ lg: '16px', '2xl': '16px' }}>
					<Links routes={routes} />
				</Box>
			</Stack>

			<Flex
				ps='20px'
				pe='16px'
				mb='32px'
				mt='16px'
				align='center'
				gap='12px'
				cursor='pointer'
				onClick={() => signOut()}
				opacity={0.7}
				_hover={{ opacity: 1 }}
				transition='opacity 0.2s'
			>
				<Icon as={MdLogout} w='20px' h='20px' color={textColor} />
				<Text fontSize='sm' fontWeight='500' color={textColor}>
					Cerrar sesión
				</Text>
			</Flex>
		</Flex>
	);
}

export default SidebarContent;
